import { checkRequiredConfigProperties } from './addons-config-adapter-common';
// Internal Config
// Client Config when Remote Config is disabled
export function adaptNativeReportingClientConfig(config) {
    return config;
}
// Server Config when Remote Config is enabled
// Client Config when Remote Config is enabled
export function adaptNativeReportingRemoteConfigSplit(config) {
    var clientConfig = config.clientConfig;
    var requiredFields = {
        appId: null,
        appPrefix: null
    };
    var missingProperties = checkRequiredConfigProperties(clientConfig || {}, requiredFields);
    if (missingProperties.length > 0) {
        return;
    }
    return {
        appId: clientConfig.appId,
        appPrefix: clientConfig.appPrefix
    };
}

//# sourceMappingURL=native-reporting-config-adapter.js.map